import React from "react"
import * as styles from './styles/video.module.css'
import * as imgstyles from "../ImageHolder/styles/imageholder.module.css"

const Video = ({ src, title, size }) => (
	<div className={styles.container}>
		<div className={`${imgstyles.imageHolder}`} style={{paddingBottom: size==="wide"?"56.25%":"75%"}}></div>
		<iframe
			src={src+"?rel=0"}
			title={title}
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
			frameBorder="0"
			webkitallowfullscreen="true"
			mozallowfullscreen="true"
			allowFullScreen
		/>
	</div>
)


export default Video